import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder } from '@angular/forms';
import { PrescriptionDataService } from "src/app-client/_dataservices/PrescriptionDataService";
import { FormTools } from "src/shared/util/FormTools";
import { ActivatedRoute } from '@angular/router';
import { BroadcastManager } from "src/app-client/_appCommon/base/BroadcastManager";
import { AppEventNames } from "src/app-client/_appCommon/base/Constants";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SetupDataService } from "src/app-client/_dataservices/SetupDataService";

@Component({
  selector: 'app-client-eighth-step',
  templateUrl: './eighth-step.component.html',
  styleUrls: ['../crud-prescription.component.css'],
  providers: [PrescriptionDataService]
})
export class EighthStepComponent extends FormTools implements OnChanges
{
  public prescriptionNumber = 8;
  public isCaseDetail: boolean;
  public customStageNumber:number; 
  private unsubscribe: Subject<void> = new Subject();

  @Input('prescriptionData') public prescriptionData! : any;

  constructor(formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private prescriptionDataService: PrescriptionDataService,private setupDataService:SetupDataService)
  {
    super(10, formBuilder);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['prescriptionData'] != undefined && changes['prescriptionData'].currentValue !=  undefined){
      this.stepFormGroup?.controls['useDentalResinAnchors'].setValue(changes['prescriptionData'].currentValue.useDentalResinAnchors);
      this.stepFormGroup?.controls['stage'].setValue(changes['prescriptionData'].currentValue.stage);
      this.stepFormGroup?.controls['isNoPlaceDentalAnchors'].setValue(changes['prescriptionData'].currentValue.isNoPlaceDentalAnchors);
      this.stepFormGroup?.controls['noPlaceDentalAnchorsPieces'].setValue(changes['prescriptionData'].currentValue.noPlaceDentalAnchorsPieces);
      this.stepFormGroup?.controls['dentalAnchorsComments'].setValue(changes['prescriptionData'].currentValue.dentalAnchorsComments);
      if (this.stepFormGroup?.controls['stage'].value != 1 && this.stepFormGroup?.controls['stage'].value != 2 &&this.stepFormGroup?.controls['stage'].value!=null) 
      {
        this.customStageNumber = this.stepFormGroup?.controls['stage'].value;
      }
      else 
      {
        this.customStageNumber = null
        if(this.stepFormGroup?.controls['stage'].value==null)
        {
          this.stepFormGroup?.controls['stage'].setValue(1);
        }
        
      }
      

      
    } 
  }

  ngOnInit(): void
  {
    this.activatedRoute.url.subscribe( url =>
    {
      this.isCaseDetail = url.toString().contains('detail');
    });

    BroadcastManager.Instance.on(AppEventNames.onUpdatePrescriptionStepByNumber)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        let number = e[0];

        if (number && this.prescriptionNumber == number)
          this.updateStepPrescription();
      });

    this.stepFormGroup = this.formBuilder.group({
      id: [0, null],
      useDentalResinAnchors: [true, null],
      stage: [1, null],
      isNoPlaceDentalAnchors: [false, null],
      noPlaceDentalAnchorsPieces: [[], null],
      dentalAnchorsComments: ['', null],
    });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public updateStepPrescription(): void
  {
    // Set prescriptionId in stepFormGroup
    this.stepFormGroup.controls['id'].setValue(this.GetPrescriptionId);
    this.prescriptionDataService.updatePrescriptionStep(this.GetSetupId, this.prescriptionNumber, this.stepFormGroup.value)
      .subscribe((response) =>
      {
        let body = 
        {
          id: this.GetSetupId,
          currentStep: 2,
          resetCurrentStepToStart:true
        };
        this.updateSetupCurrentStep(body);
        this.setSuccessAlert('Paso guardado correctamente');
      }, fail =>
      {
        this.setWarningAlert('Hubo un error al actualizar la prescripción: '+ fail.error.message);
      });
  }

  public selectStageOptions= [
    { value: 1, display: "1"},
    { value: 2, display: "2"},
  ];

  public onCustomStageChange(e)
  {
    this.customStageNumber = e;
    this.stepFormGroup?.controls['stage'].setValue(this.customStageNumber);
  }

  private updateSetupCurrentStep(body: any)
  {

    this.setupDataService.updateSetupCurrentStep(body)
    .subscribe(()=>
    {
      this.setCurrentSetupStep(body.currentStep);
    });
  }
}
